(function AppOptimization () {
  'use strict'

  const supportsPassive = getPassiveSupport()
  const cfg = JSON.parse(document.getElementById('pjs-app-optimization').textContent)
  const page = cfg.page
  const debug = cfg.debug

  modifyCreateElement(cfg.apps.map(loadTypeFromSettings).map(eventsFromSettings).map(outputLogic))

  function loadTypeFromSettings (settings) {
    if (settings['settings_' + page]) settings.loadType = 'settings'
    else if (settings['scroll_' + page]) settings.loadType = 'scroll'
    else settings.loadType = 'interaction'
    return settings
  }

  function eventsFromSettings (settings) {
    if (settings.loadType !== 'interaction') return settings

    settings.interactionEvents = []
    const selectorList = [settings.interaction_selectors_1, settings.interaction_selectors_2]
    const eventList = [settings.interaction_event_1, settings.interaction_event_2]

    selectorList.forEach(function (selector, index) {
      if (selector.length) {
        settings.interactionEvents.push({
          nodes: nodeList(selector),
          event: eventList[index]
        })
      }
    })
    return settings
  }

  function outputLogic (settings) {
    const data = {
      url: settings.url,
      loadType: settings.loadType,
      interactionEvents: settings.interactionEvents
    }
    if (debug) console.log('App Optimization Data:', data)
    return data
  }

  function modifyCreateElement (logic) {
    const createElementBackup = document.createElement

    document.createElement = function () {
      const args = Array.prototype.slice.call(arguments)
      const node = createElementBackup.bind(document).apply(undefined, args)

      // Skip if this is not a script tag
      if (first(args).toLowerCase() !== 'script') return node

      const originalSetAttribute = node.setAttribute.bind(node)

      Object.defineProperties(node, {
        src: {
          get () {
            return node.getAttribute('src') || ''
          },
          set (src) {
            const loadRule = getLoadRule(logic, src)
            if (loadRule) {
              // Remove app from logic once matched
              logic.forEach(function (item, index) {
                if (item.url === loadRule.url) logic.splice(index, 1)
              })

              // Change script MIME type if script should not load
              originalSetAttribute('type', 'javascript/blocked')
              loadRule.originalUrl = src
              if (loadRule.loadType === 'interaction') {
                window.addEventListener('load', interactionLoad(loadRule), false)
              }
              if (loadRule.loadType === 'scroll') {
                window.addEventListener('load', scrollLoad(loadRule), false)
              }
            }
            originalSetAttribute('src', src)
            return true
          }
        }
      })
      return node
    }
  }

  function interactionLoad (loadRule) {
    loadRule.interactionEvents.forEach(function (interactionEvent) {
      interactionEvent.nodes.forEach(function (node) {
        const eventFn = partial(loadScript, loadRule.originalUrl)
        const eventOptions = supportsPassive ? { once: true } : false
        node.addEventListener(interactionEvent.event, eventFn, eventOptions)
      })
    })
  }

  function scrollLoad (loadRule) {
    const eventFn = partial(loadOnScroll, loadRule.originalUrl)
    const eventOptions = supportsPassive ? { passive: true } : false
    window.addEventListener('scroll', eventFn, eventOptions)

    function loadOnScroll (src) {
      loadScript(src)
      window.removeEventListener('scroll', eventFn, eventOptions)
    }
  }

  function getLoadRule (logic, src) {
    return first(
      logic.filter(function (item) {
        return stringIncludes(src, item.url)
      })
    )
  }

  function getPassiveSupport () {
    let supportsPassive = false
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: function () {
          supportsPassive = true
        }
      })
      window.addEventListener('testPassive', null, opts)
      window.removeEventListener('testPassive', null, opts)
    } catch (e) {}
    return supportsPassive
  }

  function loadScript (src) {
    const script = document.querySelector('script[type="javascript/blocked"][src="' + src + '"]')
    if (!script) return

    const newScript = document.createElement('script')
    newScript.src = script.src
    newScript.async = true
    newScript.setAttribute('data-app-optimization', true)
    document.body.appendChild(newScript)

    if (debug) console.log('App Optimization Script Load:', newScript)
  }

  function nodeList (str) {
    let nodes = []
    try {
      nodes = Array.prototype.slice.call(document.querySelectorAll(str))
    } catch {}
    return nodes
  }

  function stringIncludes (str1, str2) {
    return String(str1).indexOf(String(str2)) != -1
  }

  function first (arr) {
    return arr[0]
  }

  function partial (fn) {
    const slice = Array.prototype.slice
    const args = slice.call(arguments, 1)
    return function () {
      return fn.apply(this, args.concat(slice.call(arguments, 0)))
    }
  }
})()
